import React from 'react';
import { HomeWhyPartnerProps } from './home-why-partner.props';
import { GetInTouchMolecule } from '../../molecules/get-in-touch';
import {
  IconPartnerMolecule,
  IconWaldoGraphMolecule,
  IconLoyaltyProgramMolecule,
} from '../../molecules';
import LazyLoad from 'react-lazyload';

export const HomeWhyPartnerOrganism = (props: HomeWhyPartnerProps) => {
  return (
    <section
      className=" block bg-waldo-blue pt-0 lg:pt-5 pb-10 lg:pb-16 z-20 relative"
      id="whyPartnerWithUs"
    >
      <div className="w-11/12 lg:w-4/5 mx-auto pt-8 lg:pt-12">
        <h2 className="text-white block w-full text-center mb-0 lg:mb-7">
          {props.title}
        </h2>
        <div className="w-full  lg:w-13/20 mx-auto mb-0 lg:mb-5">
          <div className="w-full pt-4 pb-8 lg:pb-12 lg:pt-8 border-b border-white border-opacity-30  mt-2.5">
            <div className="w-full mx-auto flex flex-row">
              <div className="w-6 lg:w-1/15 min-w-max">
                <div className="text-xl text-white text-opacity-60 text-left relative">
                  1
                </div>
              </div>
              <div className="w-4/5">
                <p className="-mt-0.5 text-white font-waldo-regular font-light text-mobileHeader ml-3 text-left">
                  {props.content.TITLE_1}
                </p>
              </div>
            </div>
            <div className="w-93/100 lg:w-7/10 mx-auto">
              <div className="flex flex-row justify-start items-center ml-5 lg:ml-1 mt-5">
                <div className="w-7/20 lg:w-1/3">
                  <LazyLoad offset={150} height={150}>
                    <IconPartnerMolecule />
                  </LazyLoad>
                </div>
                <p className="text-white font-light w-4/5 hidden lg:block leading-6">
                  {props.content.DESC_1}
                </p>
                <p className="text-white font-light w-7/10 pl-1 block ml-2 lg:hidden leading-6">
                  {props.content.DESC_1_mobile}
                </p>
              </div>
              <p className="text-white font-light block lg:hidden mt-5 ml-5 leading-6">
                {props.content.DESC_1_mobile_1}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-13/20 mx-auto my-0 lg:my-8 ">
          <div className="w-full pt-8 pb-8 lg:pb-16 lg:pt-10 border-b border-white border-opacity-30 mt-2.5">
            <div className="w-full mx-auto flex flex-row">
              <div className="w-6  lg:w-1/15 min-w-max">
                <div className="text-xl text-white text-opacity-60 text-left relative">
                  2
                </div>
              </div>
              <div className="w-4/5">
                <p className="-mt-0.5 text-white font-waldo-regular font-light text-mobileHeader ml-3 text-left">
                  {props.content.TITLE_2}
                </p>
              </div>
            </div>
            <div className="w-full lg:w-7/10 lg:mx-auto">
              <p className="text-white font-light ml-9 lg:ml-4 mt-2 leading-6">
                {props.content.DESC_2}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full  lg:w-13/20 mx-auto my-0 lg:my-8">
          <div className="w-full pt-8 pb-8  lg:pb-16 lg:pt-10 border-b border-white border-opacity-30 mt-2.5">
            <div className="w-full mx-auto flex flex-row">
              <div className="w-6  lg:w-1/15 min-w-max">
                <div className="text-xl text-white text-opacity-60 text-left relative">
                  3
                </div>
              </div>
              <div className="w-4/5">
                <p className="-mt-0.5 text-white font-waldo-regular font-light text-mobileHeader ml-3 text-left">
                  {props.content.TITLE_3}
                </p>
              </div>
            </div>
            <div className="w-full flex flex-row lg:justify-end">
              <div className="text-white font-light ml-8 lg:ml-2 mt-2 pl-1  w-full lg:w-21/25">
                <div className="max-w-full lg:max-w-lg">
                  <p className="text-white font-light leading-6">
                    {props.content.DESC_3}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full  lg:w-13/20 mx-auto my-0 lg:my-8">
          <div className="w-full py-8 lg:py-10 mt-2.5">
            <div className="w-full mx-auto flex flex-row">
              <div className="w-6  lg:w-1/15 min-w-max">
                <div className="text-xl text-white text-opacity-60 text-left relative">
                  4
                </div>
              </div>
              <div className="w-4/5">
                <p className="-mt-0.5 text-white font-waldo-regular font-light text-mobileHeader ml-3 text-left">
                  {props.content.TITLE_4}
                </p>
              </div>
            </div>
            <div className="w-full lg:w-7/10 lg:mx-auto">
              <p className="text-white font-light ml-10 lg:ml-4 mt-2 leading-6">
                {props.content.DESC_4}
              </p>
              <div className="text-white font-light mt-4 ml-10 lg:ml-4 w-68  lg:w-full max-w-full lg:max-w-md flex flex-nowrap items-start">
                <img
                  src="/images/icons/double-arrow.svg"
                  className="inline-block mr-2 align-middle mb-1 mt-2"
                />
                {props.content.DESC_4_3}
              </div>
              <div className="flex flex-col lg:flex-row justify-start mt-4 lg:mt-10 items-center ml-0 lg:ml-4 ">
                <div className="w-9/10 lg:w-3/5 py-2.5 lg:py-0 ml-10 lg:ml-0">
                  <LazyLoad offset={200} height={200}>
                    <IconWaldoGraphMolecule />
                  </LazyLoad>
                </div>
                <p className="w-9/10  lg:w-full  ml-8 lg:ml-0 lg:w-70 text-white font-light items-center mt-5 lg:mt-0 text-base leading-6 ">
                  {props.content.DESC_4_2}
                </p>
              </div>
            </div>
          </div>
        </div>

        <GetInTouchMolecule label={props.button} addClass="pt-3.5 lg:pt-10" />
      </div>
    </section>
  );
};
